import invariant from 'invariant';
import immer, { enableMapSet } from 'immer';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

var Dispatcher = /*#__PURE__*/function () {
  function Dispatcher() {
    _classCallCheck(this, Dispatcher);

    this.listeners = [];
  }

  _createClass(Dispatcher, [{
    key: "listen",
    value: function listen(listener) {
      this.listeners.push(listener);
    }
  }, {
    key: "dispatch",
    value: function dispatch(type, payload) {
      var action = {
        type: type,
        payload: payload
      };
      this.listeners.forEach(function (listener) {
        return listener(action);
      });
    }
  }]);

  return Dispatcher;
}();

var StoreContext = /*#__PURE__*/function () {
  function StoreContext() {
    var _this = this;

    _classCallCheck(this, StoreContext);

    this.updateQueue = new Set();
    this.animateId = -1;

    this.batch = function (cb) {
      return cb();
    };

    this.dispatchChange = function () {
      if (_this.updateQueue.size <= 0) return;

      _this.batch(function () {
        _this.updateQueue.forEach(function (store) {
          return store._emit();
        });

        _this.updateQueue.clear();
      });
    };
  }

  _createClass(StoreContext, [{
    key: "injectBatch",
    value: function injectBatch(batch) {
      this.batch = batch;
    }
  }, {
    key: "enqueueToUpdate",
    value: function enqueueToUpdate(store) {
      this.updateQueue.add(store);

      if (typeof requestAnimationFrame === 'function') {
        // batched update in client side
        cancelAnimationFrame(this.animateId);
        this.animateId = requestAnimationFrame(this.dispatchChange);
      } else {
        this.dispatchChange();
      }
    }
  }]);

  return StoreContext;
}();

var AppContext = /*#__PURE__*/function () {
  function AppContext(app) {
    var _this = this;

    _classCallCheck(this, AppContext);

    this.app = app;
    this.stores = new Map();
    this.actionCallbackMap = new Map();
    this.dispatcher = new Dispatcher();
    this.storeContext = new StoreContext();
    this.app.stores.forEach(function (StoreClass) {
      _this.initializeStore(StoreClass);
    });
    this.getStore = this.getStore.bind(this);
    this.executeOperation = this.executeOperation.bind(this);
    this.dispatch = this.dispatch.bind(this);
    this.depend = this.depend.bind(this);
    var self = this;
    this.operationContext = {
      get executeOperation() {
        return self.executeOperation;
      },

      get dispatch() {
        return self.dispatch;
      },

      get getStore() {
        return self.getStore;
      },

      get depend() {
        return self.depend;
      }

    };
    this.componentContext = {
      executeOperation: function executeOperation(op) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        self.executeOperation.apply(self, [op].concat(args));
      },

      get getStore() {
        return self.getStore;
      },

      get depend() {
        return self.depend;
      }

    };
  }

  _createClass(AppContext, [{
    key: "dehydrate",
    value: function dehydrate() {
      var state = {
        stores: {}
      };
      this.stores.forEach(function (store, storeName) {
        state.stores[storeName] = store.dehydrate();
      });
      return state;
    }
  }, {
    key: "rehydrate",
    value: function rehydrate(state) {
      var _this2 = this;

      this.app.stores.forEach(function (StoreClass) {
        if (!state.stores[StoreClass.storeName]) return;

        if (!_this2.stores.has(StoreClass.storeName)) {
          _this2.initializeStore(StoreClass);
        }

        _this2.stores.get(StoreClass.storeName).rehydrate(state.stores[StoreClass.storeName]);
      });
    }
  }, {
    key: "depend",
    value: function depend(obj) {
      return obj;
    }
  }, {
    key: "getStore",
    value: function getStore(StoreClass) {
      var storeName = typeof StoreClass === 'string' ? StoreClass : StoreClass.storeName;

      if (process.env.NODE_ENV !== 'production') {
        var storeRegistered = this.app.stores.has(storeName);
        invariant(storeRegistered, "Store ".concat(storeName, " is must be registered"));
      }

      return this.stores.get(storeName) || this.initializeStore(storeName);
    }
  }, {
    key: "executeOperation",
    value: function executeOperation(operation) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return __awaiter(this, void 0, void 0, function* () {
        yield Promise.resolve(operation.apply(void 0, [this.operationContext].concat(args)));
      });
    }
  }, {
    key: "dispatch",
    value: function dispatch(actionIdentifier, payload) {
      this.dispatcher.dispatch(actionIdentifier, payload);
    }
  }, {
    key: "initializeStore",
    value: function initializeStore(StoreClass) {
      var _this3 = this;

      var storeName = typeof StoreClass === 'string' ? StoreClass : StoreClass.storeName;

      if (process.env.NODE_ENV !== 'production') {
        var storeRegistered = this.app.stores.has(storeName);
        invariant(storeRegistered, "Store ".concat(storeName, " is must be registered"));
      }

      var StoreConstructor = this.app.stores.get(storeName);
      var store = new StoreConstructor(this.storeContext);
      var actionCallbackMap = new Map();
      this.stores.set(storeName, store);
      Object.keys(store).filter(function (key) {
        return store[key] != null && store[key].__fleurHandler;
      }).forEach(function (key) {
        var actionIdentifier = store[key].__action;
        var actionCallbacks = actionCallbackMap.get(actionIdentifier) || [];
        actionCallbacks.push(store[key].producer);
        actionCallbackMap.set(actionIdentifier, actionCallbacks);
      });
      this.actionCallbackMap.set(StoreConstructor, actionCallbackMap);
      this.dispatcher.listen(function (action) {
        var actionCallbackMap = _this3.actionCallbackMap.get(StoreConstructor);

        var handlers = actionCallbackMap.get(action.type);

        if (handlers) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = handlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var handler = _step.value;
              handler(action.payload);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      });
      return store;
    }
  }]);

  return AppContext;
}();

var Fleur = /*#__PURE__*/function () {
  function Fleur() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Fleur);

    this.stores = new Map();

    if (options.stores) {
      options.stores.forEach(function (StoreClass) {
        return _this.registerStore(StoreClass);
      });
    }
  }

  _createClass(Fleur, [{
    key: "registerStore",
    value: function registerStore(Store) {
      if (typeof Store.storeName !== 'string' || Store.storeName === '') {
        console.error('Store.storeName must be specified.', Store);
        throw new Error('Store.storeName must be specified.');
      }

      var storeRegistered = this.stores.has(Store.storeName);
      invariant(!storeRegistered, "Store ".concat(Store.storeName, " already registered."));
      this.stores.set(Store.storeName, Store);
    }
  }, {
    key: "createContext",
    value: function createContext() {
      return new AppContext(this);
    }
  }]);

  return Fleur;
}();

var listen = function listen(action, producer) {
  return {
    __fleurHandler: true,
    __action: action,
    producer: producer
  };
};
var Store = /*#__PURE__*/function () {
  function Store(context) {
    _classCallCheck(this, Store);

    this.context = context;
    this.requestId = null;
    this.listeners = [];
    enableMapSet();
  }

  _createClass(Store, [{
    key: "on",
    value: function on(listener) {
      this.listeners.push(listener);
    }
  }, {
    key: "off",
    value: function off(listener) {
      this.listeners = this.listeners.filter(function (l) {
        return l !== listener;
      });
    }
    /** DO NOT USE THIS, It's internal method */

  }, {
    key: "_emit",
    value: function _emit() {
      this.listeners.forEach(function (listener) {
        return listener();
      });
    }
  }, {
    key: "rehydrate",
    value: function rehydrate(state) {
      this.state = state;
    }
  }, {
    key: "dehydrate",
    value: function dehydrate() {
      return this.state;
    }
  }, {
    key: "emitChange",
    value: function emitChange() {
      this.context.enqueueToUpdate(this);
    }
  }, {
    key: "updateWith",
    value: function updateWith(producer) {
      this.state = immer(this.state, function (draft) {
        producer(draft);
      });
      this.context.enqueueToUpdate(this);
    }
  }]);

  return Store;
}();
Store.storeName = '';
var reducerStore = function reducerStore(storeName, initialStateFactory) {
  var _a;

  var Sub = (_a = /*#__PURE__*/function (_Store) {
    _inherits(_a, _Store);

    function _a(context) {
      var _this;

      _classCallCheck(this, _a);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(_a).call(this, context));
      _this.context = context;
      _this.state = initialStateFactory();
      Sub.listeners.forEach(function (_ref, idx) {
        var _ref2 = _slicedToArray(_ref, 2),
            ident = _ref2[0],
            producer = _ref2[1];
        _this["__handler".concat(idx, "_").concat(ident.name)] = listen(ident, function (payload) {
          _this.updateWith(function (d) {
            return producer(d, payload);
          });
        });
      });
      return _this;
    }

    _createClass(_a, null, [{
      key: "listen",
      value: function listen(ident, producer) {
        Sub.listeners.push([ident, producer]);
        return this;
      }
    }]);

    return _a;
  }(Store), _a.storeName = storeName, _a.listeners = [], _a);
  return Sub;
};

var action = function action(name) {
  var identifier = function identifier() {
    throw new Error('Do not call ActionIdentifier as function');
  };

  if (name) {
    Object.defineProperty(identifier, 'name', {
      value: name
    });
  }

  return identifier;
};

action.async = function () {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return {
    started: action(name + '.started'),
    done: action(name + '.done'),
    failed: action(name + '.failed')
  };
};

function actions(namePrefix, actionMap) {
  var separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '/';
  Object.keys(actionMap).forEach(function (key) {
    if (typeof actionMap[key] === 'function') {
      Object.defineProperty(actionMap[key], 'name', {
        value: "".concat(namePrefix).concat(separator).concat(key)
      });
    } else {
      actions("".concat(namePrefix).concat(separator).concat(key), actionMap[key], '.');
    }
  });
  return actionMap;
}

/** Make Operation group from objects */
var operations = function operations(_operations) {
  return _operations;
};
/** Make one Operation function */

var operation = function operation(op) {
  return op;
};

/** Create selector with Store#state getter */
var selector = function selector(deps, _selector) {
  if (Array.isArray(deps) && !!_selector) {
    return function (getStore) {
      var results = deps.map(function (selector) {
        return selector(getStore);
      });

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return _selector.apply(void 0, [results].concat(args));
    };
  }

  return function (getStore) {
    var getState = function getState(StoreClass) {
      return getStore(StoreClass).state;
    };

    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return deps.apply(void 0, [getState].concat(args));
  };
};

/**
 * Create selector with Store instance. it's not recommended to usually.
 * Pleast use `selector()` first.
 */
var selectorWithStore = function selectorWithStore(deps, selector) {
  if (Array.isArray(deps) && !!selector) {
    return function (getStore) {
      var results = deps.map(function (selector) {
        return selector(getStore);
      });

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return selector.apply(void 0, [results].concat(args));
    };
  }

  return deps;
};

var withReduxDevTools = function withReduxDevTools(context) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$enableTimeTravel = _ref.enableTimeTravel,
      enableTimeTravel = _ref$enableTimeTravel === void 0 ? true : _ref$enableTimeTravel;

  // Ignore in SSR environment
  if (typeof window === 'undefined') return context;
  if (!window.__REDUX_DEVTOOLS_EXTENSION__) return context;

  var devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect();

  devTools.subscribe(function (_ref2) {
    var type = _ref2.type,
        payload = _ref2.payload,
        state = _ref2.state;
    if (type !== 'DISPATCH') return;

    if (!enableTimeTravel) {
      console.log('[fleur-redux-devtools] Time traveling is disabled');
      return;
    }

    if (payload.type === 'TOGGLE_ACTION') {
      console.log("[fleur-redux-devtools] Skip action doesn't supported.");
      return;
    }

    var stores = JSON.parse(state);
    context.rehydrate({
      stores: stores
    });
    context.stores.forEach(function (store) {
      return store.emitChange();
    });
  });
  var dispatch = context.dispatch;

  context.dispatch = function (actionIdentifier, payload) {
    dispatch(actionIdentifier, payload);
    devTools.send({
      type: actionIdentifier.name,
      payload: payload
    }, context.dehydrate().stores);
  };

  return context;
};

export default Fleur;
export { AppContext, Store, StoreContext, action, actions, listen, operation, operations, reducerStore, selector, selectorWithStore, withReduxDevTools };
